<template>
    <v-app>
        <v-container class="pa-0 pa-sm-3 pa-md-3 mt-n5">
            <v-alert v-if="alert" dense :type="coloralert" style="position: fixed; top: 8 ; right: 0 ; z-index: 3">
                <strong>{{ msg }}</strong>
            </v-alert>
            <div class="pt-16 pa-6 pa-sm-4 pa-md-4 d-none d-md-block">
                <!-- <v-switch x-small v-model="$vuetify.theme.dark" class="mt-n1 mr-2"></v-switch> -->
                <v-col cols="12" class="pl-7">
                    <v-card class="mt-7 elevation-0 mb-5">
                        <v-toolbar class="mt-3 mb-1 px-1 toolbar-contant" elevation="0" color="white">
                            <v-list class="mr-2" style="background-color: transparent;">
                                <v-list-item class="px-0 pt-0">
                                    <v-list-item-content class=" pt-0">
                                        <v-list-item-title class="text-start"
                                            style="color: #000000;font-size: 20px;font-weight:559;line-height:19px;letter-spacing:-1px">
                                            P&L Insights </v-list-item-title>

                                        <v-list-item-subtitle class="text-start pt-1"
                                            style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Straight
                                            to the point about profit and loss analysis.
                                        </v-list-item-subtitle>
                                        <!-- <v-list-item-subtitle class="text-start pt-1"
                                            style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Old
                                            format P&L Reference Available <a href="/pnl">Click here</a>
                                        </v-list-item-subtitle> -->
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-spacer></v-spacer>


                            <v-select :disabled="loader" label="Filled" :items="filterr" @change="filterseg()" dense
                                rounded solo flat v-model="filterdata_unpl" placeholder="filter"
                                background-color="#F1F3F8" hide-details class="mr-5 mt-n3 fildrop"
                                style="max-width: 140px; font-size: 21px">

                                <template v-slot:selection="{ item }">
                                    <span class="font-weight-medium caption">{{ item }}</span>
                                </template>
                            </v-select>
                            <v-text-field style="max-width: 250px" class="tophundraedmutual d-none d-md-block mt-4 mr-5"
                                height="36px" background-color="#F1F3F8" label="Search" v-model="search" solo rounded
                                text flat dense>
                                <template v-slot:prepend-inner>
                                    <img alt="" class="shrink" :src="require('@/assets/searchicon.svg')" width="20px"
                                        height="18px" />
                                </template>
                            </v-text-field>
                            <v-menu :disabled="loader" class="" v-model="menuForDatePicker"
                                :close-on-click="fromdate.length == 2" :close-on-content-click="false" offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :disabled="loader" style="max-width: 240px;" class="mt-4 mr-2" solo
                                        rounded flat v-model="fromshow" label="From date" dense color="black"
                                        background-color="#F1F3F8" prepend-inner-icon="mdi-calendar" readonly
                                        v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-card class="pa-2">
                                    <div>
                                        <v-date-picker range :min="minval" :max="maxval" color="black"
                                            v-model="fromdate" @input="datemaxvalue('click')"></v-date-picker>
                                        <!-- <v-date-picker  range color="black" v-model="fromdate" @change="getCalenderData()"></v-date-picker> -->
                                    </div>
                                    <!-- <p v-if="fromdate != '' && fromdate != [] && highlightyearsValue != 'cur'" class="ml-2 caption mb-1 "><span class="red--text">*</span>Your are in {{Number(maxval.split("-")[0]) - 1}}-{{maxval.split("-")[0]}} Financial year 
                                        <v-tooltip  color="black" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                           <span @click="reset"
                                             class="caption blue--text font-weight-bold"
                                        
                                            style="cursor: pointer"
                                            v-bind="attrs"
                                            v-on="on">
                                            Change
                                           </span>
                                        </template>
                                        <span>Click here to move the date forward for Financial year</span>
                                        </v-tooltip>Fsort
                                    </p> -->
                                    <p class="text-right mb-2">
                                        <v-tooltip v-if="fromdate != [] " color="black" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span @click="reset" class="caption blue--text font-weight-bold"
                                        style="cursor: pointer" v-bind="attrs" v-on="on">
                                        Reset
                                    </span>
                                </template>
                                <span>Click here to Resets date</span>
                            </v-tooltip>
                                    </p>
                                    <p 
                            class="ml-2 caption mb-1 text-center">
                            <span class="red--text">*</span>
                            <!-- Your are in {{ Number(maxval.split("-")[0]) -
                                1 }}-{{ maxval.split("-")[0] }} Financial year -->
                                 Here you can only see the current Financial year Data
                                 <br>
                                  <span>Other financial data available in <span  style="cursor: pointer;" class="blue--text" @click="redirecttotax">Tax pnl page  </span> </span>
                            
                        </p>
                                    <!-- <v-divider></v-divider>
                                    <div class="d-flex mt-n2">
                                        <p class="mb-0 mx-1 pa-4 body-2 font-weight-black" style="cursor: pointer;" @click="gettradedataextra(7)">Last 7 days</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"  @click="gettradedataextra(30)">Last 30 days</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                            :class="{ 'blue--text': highlightyearsValue == 'cur', 'black--text': highlightyearsValue != 'cur' }"
                                            @click="GetDataWithYearSelector(0, 'cur')">Current FY</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                            :class="{ 'blue--text': highlightyearsValue == 'lyear', 'black--text': highlightyearsValue != 'lyear' }"
                                            @click="GetDataWithYearSelector(-1, 'lyear')">Last FY</p>

                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                            :class="{ 'blue--text': highlightyearsValue == yearsarray[0], 'black--text': highlightyearsValue != yearsarray[0] }"
                                            @click="GetDataWithYearSelector(-2, yearsarray[0])">{{ yearsarray[0] }}</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                            :class="{ 'blue--text': highlightyearsValue == yearsarray[1], 'black--text': highlightyearsValue != yearsarray[1] }"
                                            @click="GetDataWithYearSelector(-3, yearsarray[1])">{{ yearsarray[1] }}</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                            :class="{ 'blue--text': highlightyearsValue == yearsarray[2], 'black--text': highlightyearsValue != yearsarray[2] }"
                                            @click="GetDataWithYearSelector(-4, yearsarray[2])">{{ yearsarray[2] }}</p>
                                        <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" @click="mountedfun(30)">Last </p>
                                    </div> -->
                                </v-card>

                            </v-menu>


                            <!-- dense prepend-inner-icon="mdi-filter-variant" -->

                            <!-- <v-select v-if="!downsum" :items="filterr" @change="filterseg1(filterdata_unpl1)" dense
                                v-model="filterdata_unpl1" placeholder="filter" solo rounded flat background-color="#F1F3F8"
                                hide-details class="mr-2 mt-n2 fildrop" style="max-width: 140px; font-size: 21px">
                            </v-select> -->
                            <!-- <v-btn v-if="downsum" @click="downloadsum()" class="elevation-0 rounded-pill mt-n2 mr-2"><v-icon
                                    size="20">mdi mdi-content-save</v-icon></v-btn>
                            <v-btn v-if="!downsum" @click="downloaddet()"
                                class="elevation-0 rounded-pill mt-n2 mr-2"><v-icon size="20">mdi
                                    mdi-content-save</v-icon></v-btn> -->

                        </v-toolbar>
                        <v-divider></v-divider>
                        <div class="display-flex row   d-none d-md-block pa-8">
                            <v-row>
                                <v-col class="col-md-4 col-lg-2 col-sm-3  ">
                                    <v-card class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Realised P&L</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p :class="RealishedPnl > 0 ? 'green--text' : RealishedPnl < 0 ? 'red--text' : 'black--text'"
                                                    class="mb-0"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ (RealishedPnl).toFixed(2) }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col class="col-md-4 col-lg-2 col-sm-3  ">
                                    <v-card class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Unrealised P&L</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p :class="UnRealishedPnl > 0 ? 'green--text' : UnRealishedPnl < 0 ? 'red--text' : 'black--text'"
                                                    class="mb-0"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ (UnRealishedPnl).toFixed(2) }}
                                                </p>

                                            </v-card>
                                        </div>
                                    </v-card>

                                </v-col>
                                <v-col cols=" " class="col-md-4 col-lg-2 col-sm-3  ">
                                    <v-card class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Charges & taxes</p>

                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <!-- <v-skeleton-loader  max-width="300" height="10"
                                                type="card"></v-skeleton-loader> -->

                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ (TaxesAndCharges).toFixed(2) }}
                                                </p>

                                            </v-card>
                                        </div>
                                    </v-card>

                                </v-col>
                                <v-col cols=" " class="col-md-4 col-lg-2 col-sm-3  ">
                                    <v-card class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Net Realised P&L</p>

                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <!-- <v-skeleton-loader  max-width="300" height="10"
                                                type="card"></v-skeleton-loader> -->

                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p :class="(RealishedPnl - TaxesAndCharges) > 0 ? 'green--text' : (RealishedPnl - TaxesAndCharges) < 0 ? 'red--text' : 'black--text'"
                                                    class="mb-0"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ ((RealishedPnl - TaxesAndCharges)).toFixed(2) }}
                                                </p>

                                            </v-card>
                                        </div>
                                    </v-card>

                                </v-col>
                                <!-- P&L verified by Zebu -->
                                <v-col v-if="TableData.length > 0" cols="" class="col-md-4 col-lg-2 col-sm-3  ">
                                    <div class="mt-4 ml-4">
                                        <p class="mt-2 mb-3" style="
                                                font-weight: 450;
                                                font-size: 14px;
                                                color: #4b4b4b;
                                                line-height: 16px;
                                                letter-spacing: -0.4px;
                                            ">
                                            <v-icon size="16" color="green" class="pt-n2">mdi mdi-check-circle</v-icon>
                                            P&L verified by Zebu

                                        </p>


                                        <v-row>
                                            <v-col cols="7" class="pa-0 pl-3">


                                                <p class="mt-2 mb-0 " style="font-size: 12px">Share to Everyone</p>
                                                <div class="d-flex mt-n1">
                                                    <v-switch color="black" @change="switchbtn" class="mt-1"
                                                        v-model="agreeforshare" inset dense></v-switch>
                                                    <v-btn class="mt-2 px-3" disabled rounded x-small
                                                        v-if="!agreeforshare">
                                                        <v-icon class="" size="16">mdi mdi-share-variant</v-icon>
                                                    </v-btn>
                                                    <v-btn dark class="mt-2 px-3" rounded x-small v-else
                                                        @click="dialogcopytext = true">
                                                        <v-icon color="white" class="" size="16">mdi
                                                            mdi-share-variant</v-icon>
                                                    </v-btn>

                                                </div>
                                            </v-col>

                                        </v-row>

                                    </div>
                                </v-col>
                                <!-- {{dessertspopexpense}} -->
                            </v-row>
                        </div>
                        <!-- <v-list-item-title class="text-start ml-6"
                        style="color: #000000;font-size: 20px;font-weight:559;line-height:20px;letter-spacing:-1px">
                        Statistics </v-list-item-title>
                        <div class="display-flex row   d-none d-md-block pa-8">
                            <v-row>
                                <v-col cols="3">
                                   <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Trading Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Trading Days'] ? (StatArray['Trading Days'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Win Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Win Days'] ? (StatArray['Win Days'])  : 0 }}

                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Loss Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Loss Days'] ? (StatArray['Loss Days'])  : 0 }}

                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Winning Streak Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Winning Streak Days'] ? (StatArray['Winning Streak Days'])  : 0 }}

                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Losing Streak Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Losing Streak Days'] ? (StatArray['Losing Streak Days'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Win Rate</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Win Rate'] ? (StatArray['Win Rate'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Maximum Profit in a Day</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Maximum Profit in a Day'] ? (StatArray['Maximum Profit in a Day'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Maximum Loss in a Day</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Maximum Loss in a Day'] ? (StatArray['Maximum Loss in a Day'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Average Profit/Loss Daily</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Average Profit/Loss Daily'] ? (StatArray['Average Profit/Loss Daily'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Average Profit on Profit Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 green--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Average Profit on Profit Days'] ? (StatArray['Average Profit on Profit Days'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Average Loss on Loss Days</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Average Loss on Loss Days'] ? (StatArray['Average Loss on Loss Days'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col cols="3">
                                    <v-card :loading="loader" class=" pl-3  pr-2 " outlined height="90px">
                                        <p class="pt-3 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Maximum Drawdown</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p 
                                                    class="mb-0 red--text"
                                                    style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                                    {{ StatArray['Maximum Drawdown'] ? (StatArray['Maximum Drawdown'])  : 0 }}
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>

                            </v-row>
                        </div> -->

                        <!-- <div class="display-flex row   d-none d-md-block pa-8">
                            <v-row>
                                <v-col>
                                    <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                                        <p class="pt-1 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Realised P&L</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p class="mb-0"  
                                                    style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                                    567</p>
                                                
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                                        <p class="pt-1 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Unrealised P&L</p>
                                        <v-divider class="mt-2" style="border:solid px #000000" width="30px"
                                            color="#000000"></v-divider>
                                        <div class="display-flex row pt-6 pl-2">
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">

                                                <p class="mb-0"  
                                                    style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                                    567</p>
                                            </v-card>
                                        </div>
                                    </v-card>

                                </v-col>
                                <v-col>
                                    <v-card @click="chargerdialoge = true" class="ml-3 pl-3 py-1 pr-2 " outlined height="90px">
                                        <p class="pt-1 mb-3"
                                            style="font-weight:450;font-size: 16px; color: #000000;line-height: 16px;letter-spacing: -0.4px;">
                                            Charges & taxes</p>
                                        <div class="display-flex row pt-6 pl-2"> 
                                            <v-card class="py-1 px-2 elevation-0 ml-1" color="#F1F3F8">
                                                <p class="mb-0" style="color: red;font-size: 13px;font-weight: 469;line-height: 12px;letter-spacing: 0.9px;">
                                                    567
                                                </p>
                                            </v-card>
                                        </div>
                                    </v-card>
                                </v-col> 
                            </v-row>
                        </div> -->
                        <!-- {{ ChartValue }} -->
                        <v-col cols="3" class="pa-0">


                            <v-tabs v-model="tab" background-color="transparent" color="basil" grow>

                                <v-tab>
                                    Daily
                                </v-tab>

                                <v-tab>
                                    Monthly
                                </v-tab>




                            </v-tabs>
                        </v-col>
                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <v-card class="" outlined style=" height : 100%;width : 100%;overflow-x: scroll">
                                    <div v-if="loader == false" class="ml-n3 mt-4">
                                        <!-- <div id="cal-heatmap"></div> -->

                                        <div class="ml-1 pa-4" id="cal-heatmap" style=""></div>

                                    </div>
                                    <!-- <div v-else-if="loader == false" class="text-center mt-4">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="8%" height="" />
                                <p class="mb-0 caption mt-2">No data available</p>   
                            </div> -->
                                    <!-- <v-overlay v-else class="rounded-0" style="z-index:2000"> -->
                                    <div v-else class="text-center mt-4">
                                        <v-progress-circular :size="50" :width="4" color="#0037B7"
                                            indeterminate></v-progress-circular>
                                        <p class="mb-0 caption mt-4">Getting your data please wait...</p>
                                    </div>
                                    <!-- </v-overlay> -->
                                </v-card>
                                <!-- :group-by="['TRADE_DATE']"  -->




                            </v-tab-item>
                            <v-tab-item>
                                <v-card class="pl-4 pr-4" outlined
                                    style=" height : 125px;width : 100%;overflow-x: scroll">
                                    <div v-if="loader == false" class="ml-n3 mt-4 d-flex">
                                        <!-- <div id="cal-heatmap"></div> -->

                                        <div class="d-flex pl-12" style="width: 100%;">
                                            <v-card v-for="(key, val, ind) in calendermontharray" :key="ind" outlined
                                                class="ma-2 mr-3 my-4 elevation-0" style="min-width:  100px;  "
                                                :style="{ backgroundColor: Number(key.value) < 0 ? '#ffd4d4' : Number(key.value) > 0 ? '#cdfad1' : '#ededed' }">



                                                <p :style="{ color: Number(val[0].value) == 0 ? 'black' : 'black' }"
                                                    class="mb-0 caption pl-2 pt-1 pr-2" style="width: ">
                                                    {{ val.substring(0, 3) }} {{
                                                        val == 'January' || val
                                                            == 'February' || val == 'March' ? ToDateForApi.split("/")[2] :
                                                            FromDateForApi.split("/")[2] }} <br>{{

                                                        (key.value).toFixed(2)
                                                    }}</p>
                                                <!-- <p :style="{ color: Number(val[0].value) == 0 ? 'black' : 'black' }"
                                                class="mb-0 caption pl-2 pt-1 pr-2" style="width: 100px;">{{
                                                    val[0].value.toFixed(2) }} </p> -->


                                            </v-card>
                                        </div>

                                    </div>
                                    <!-- <div v-else-if="loader == false" class="text-center mt-4">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="8%" height="" />
                                <p class="mb-0 caption mt-2">No data available</p>   
                            </div> -->
                                    <!-- <v-overlay v-else class="rounded-0" style="z-index:2000"> -->
                                    <div v-else class="text-center mt-4">
                                        <v-progress-circular :size="50" :width="4" color="#0037B7"
                                            indeterminate></v-progress-circular>
                                        <p class="mb-0 caption mt-4">Getting your data please wait...</p>
                                    </div>
                                    <!-- </v-overlay> -->
                                </v-card>

                            </v-tab-item>
                        </v-tabs-items>

                        <v-col cols="3" class="pa-0 mt-5">


                            <v-tabs v-model="tab2" background-color="transparent" color="basil" grow>

                                <v-tab>
                                    Date Wise
                                </v-tab>

                                <v-tab>
                                    Script Wise
                                </v-tab>




                            </v-tabs>
                        </v-col>
                        <v-tabs-items v-model="tab2">
                            <v-tab-item>
                                <v-data-table hide-default-header :headers="HeaderFortableForexpand"
                                    :items="DateTableData" :single-expand="singleExpand"
                                    style="border: 1px solid #efeef3; cursor: pointer"
                                    class="cust-table elevation-0 rounded-lg cell-height  " fixed-header
                                    @click:row="toggleExpanded" :loading="loader" height="495px" hide-default-footer
                                    :expanded.sync="expanded" item-key="name" disable-sort :items-per-page="-1">

                                    <template v-slot:[`item.name`]="{ item }">
                                        <span class="overline"> {{ formatDate(item.name)
                                            }}
                                            (
                                            <span class="overline"> {{ (item.val).length }}</span>

                                            )
                                        </span>



                                    </template>



                                    <template v-slot:[`item.real`]="{ item }">
                                        <span class="overline" :class="{
                                            'green--text': realisedcal(item.val) > 0,
                                            'red--text': realisedcal(item.val) < 0,
                                            'black--text': realisedcal(item.val) === 0
                                        }"> {{ realisedcal(item.val) }}</span>
                                    </template>

                                    <template v-slot:expanded-item="{ headers, item }">
                                        <td class="px-0" :colspan="headers.length">
                                            <!-- {{ item.val }} -->
                                            <!-- v-if="item.name != 'Assets'" -->
                                            <v-data-table @click:row="SymbolMatchedDate"
                                                :items-per-page="item.val.length" item fixed-header hide-default-footer
                                                dense :headers="HeaderFortableForexpandinSide" :items="item.val"
                                                item-key="name" class="elevation-0">

                                                <template v-slot:[`item.SCRIP_SYMBOL`]="{ item }">
                                                    <span class="caption font-weight-bold"> {{ item.SCRIP_SYMBOL
                                                        }}</span>
                                                    <v-chip v-if="item.Open_Qty" class="ma-2" small color="green"
                                                        outlined> {{ item.Open_Qty }} @ {{ item.Open_Rate }} </v-chip>
                                                </template>

                                                <template v-slot:[`item.BQTY`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.BQTY }}</span>
                                                </template>

                                                <template v-slot:[`item.BRATE`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.BRATE
                                                        }}</span><br>
                                                    <span class=" font-weight-normal" style="font-size: 11px;"> {{
                                                        (Number(item.BRATE) * Number(item.BQTY)).toFixed(2) }}</span>
                                                </template>

                                                <template v-slot:[`item.SQTY`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.SQTY }}</span>
                                                </template>

                                                <template v-slot:[`item.SRATE`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.SRATE
                                                        }}</span><br>
                                                    <span class=" font-weight-normal" style="font-size: 11px;"> {{
                                                        (Number(item.SRATE) * Number(item.SQTY)).toFixed(2) }}</span>
                                                </template>

                                                <template v-slot:[`item.Updated_NETQTY`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.Updated_NETQTY
                                                        }}</span>
                                                </template>

                                                <template v-slot:[`item.CLOSING_PRICE`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.CLOSING_PRICE
                                                        }}</span>
                                                </template>

                                                <template v-slot:[`item.realisedpnl`]="{ item }">
                                                    <span class="caption font-weight-normal"> {{ item.realisedpnl
                                                        }}</span>
                                                </template>
                                                <!-- <template v-slot:item="{ item }">
                              <tr class=" " style=" height: 30px;">
                             
                                <td class="" style="width:350px">
                                  <span class="font-weight-bold caption mt-8"> <span >{{   item.SCRIP_SYMBOL   }}</span>
                                    

                                    
                                  </span>

                                </td>


                                <td class=" text-right" style="width: 400px">
                                    <span class="font-weight-normal caption"> <span >{{   item.total_buy_qty   }}</span>
                                    

                                    
                                </span>
                                </td>
                                <td style="width: 150px">

</td>
                                <td class=" text-right pl-0" style="width: 100px">
                                    <span class="font-weight-normal caption"> <span >{{  item.total_buy_rate   }}</span>
                                    

                                    
                                </span>
                                </td>

                                <td class="  text-right" style="width: 200px">
                                    <span class="font-weight-normal caption"> <span >{{  item.total_sell_qty     }}</span>
                                    

                                    
                                </span>
                                </td>
                                <td style="width: 200px" class="pr-0  text-right">
                                    <span class="font-weight-normal caption"> <span >{{ item.total_sell_rate  }}</span>
                                    

                                    
                                </span>

                                </td>
                                <td style="width: 200px" class="pr-0  text-right">
                                    <span class="font-weight-normal caption"> <span >{{ item.NETQTY  }}</span>
                                    

                                    
                                </span>

                                </td>
                                <td class=" text-right pr-2 " style="width: 200px">
                                    <span class="font-weight-normal caption"> <span >{{   item.CLOSING_PRICE  }}</span>
                                    

                                    
                                </span>

                                </td>
                                <td style="width: 80px">

</td>
                                <td class=" text-right " style="width: 200px">
                                    <span class="font-weight-normal caption"> <span >{{   item.realisedpnl  }}</span>
                                    

                                    
                                </span>
                                </td>
                                <td class=" text-right " style="width: 200px">
                                    <span class="font-weight-normal caption"> <span >{{   item.last  }}</span>
                                    

                                    
                                </span>
                                </td>
                                <td style="width: 80px">

                                </td>

                              </tr>
                            </template> -->


                                            </v-data-table>

                                        </td>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <v-data-table :search="search" :close-on-click="false" @click:row="SymbolMatchedDate"
                                    ref="dataTableRef" :loading="loader" mobile-breakpoint hide-default-footer
                                    height="450px" fixed-header :headers="HeaderFortable" :items="TableData"
                                    :items-per-page="TableData.length"
                                    style="cursor: pointer; border: 1px solid #EFEEF3;z-index: -1;"
                                    class="elevation-0 rounded-lg  ">
                                    <template slot="group.header" slot-scope="{  }">
                                        <!-- <tr style="background-color: ">
                        <td >
                          <strong class="mb-0 ml-2 mt-1">{{ items[0].COMPANY_CODE }}</strong>
                        </td>
                      </tr> -->
                                    </template>
                                    <template slot="group.summary" slot-scope="{ items  }">
                                        <!-- <tr> -->
                                        <td style="background-color: #F9FBFC">

                                            <p class="caption font-weight-bold  mb-0 ml-2">Total Trades:<span
                                                    class="caption font-weight-regular ml-2"> {{ items.length }}</span>
                                            </p>


                                        </td>
                                        <td style="background-color: #F9FBFC"> </td>
                                        <!-- <td style="background-color: #F9FBFC ;">

                                            <p class="caption font-weight-bold mb-0 ml-2">Total Sell : <span
                                                    class="caption  font-weight-regular  ml-2">efwee</span></p>


                                        </td> -->
                                        <td style="background-color: #F9FBFC"> </td>
                                        <td style="background-color: #F9FBFC"> </td>
                                        <td style="background-color: #F9FBFC"> </td>
                                        <td style="background-color: #F9FBFC"> </td>
                                        <td style="background-color: #F9FBFC"> </td>

                                        <td style="background-color: #f9fbfc">
                                            <p class="caption font-weight-bold  ml-2 mb-0">Realised : <span
                                                    class="font-weight-regular">
                                                    {{ realisedcal(items) }}
                                                </span> </p>
                                        </td>
                                        <!-- </tr> -->
                                    </template>
                                    <template v-slot:[`item.SCRIP_SYMBOL`]="{ item }">
                                        <span class="font-weight-bold caption">{{ item.SCRIP_SYMBOL }}</span>
                                        <!-- <p class="font-weight-normal mb-0 caption">{{ item.TRADE_DATE.split(" ")[1] +
                                            "/" +
                                            item.TRADE_DATE.split(" ")[2] + "/" + item.TRADE_DATE.split(" ")[3] }}
                                            <v-chip v-if="item.Open_Qty" class="ma-2" small color="green"
                                            outlined> {{ item.Open_Qty }} @ {{ item.Open_Rate }} </v-chip>
                                        </p>
                                             -->
                                    </template>

                                    <template v-slot:[`item.CLOSING_PRICE`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.CLOSING_PRICE }}</span>
                                    </template>

                                    <!-- <template v-slot:[`item.BAMT`]="{ item }">
                                    <span class="font-weight-regular caption">{{ item.BAMT ? (item.BAMT).toFixed(2) : 0 }}</span>
                                </template> -->

                                    <template v-slot:[`item.total_buy_qty`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.total_buy_qty }}</span>
                                    </template>

                                    <template v-slot:[`item.total_buy_rate`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.total_buy_rate ?
                                            (item.total_buy_rate).toFixed(4) : 0 }}</span>
                                        <p class="font-weight-regular caption mb-0">{{ item.total_buy_qty ?
                                            (item.total_buy_qty *
                                                item.total_buy_rate).toFixed(4) : 0 }}</p>
                                    </template>

                                    <!-- <template v-slot:[`item.SAMT`]="{ item }">
                                    <span class="font-weight-regular caption">{{ item.SAMT ? (item.SAMT).toFixed(2) : 0 }}</span>
                                </template> -->

                                    <template v-slot:[`item.total_sell_qty`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.total_sell_qty }}</span>
                                    </template>

                                    <template v-slot:[`item.total_sell_rate`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.total_sell_rate ?
                                            item.total_sell_rate.toFixed(4) : 0 }}</span>
                                        <p class="font-weight-regular caption mb-0">{{ item.total_sell_qty ?
                                            (item.total_sell_qty *
                                                item.total_sell_rate).toFixed(4) : 0 }}</p>

                                    </template>
                                    <template v-slot:[`item.Updated_NETQTY`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.Updated_NETQTY }}</span>
                                    </template>
                                    <template v-slot:[`item.remainingbprice`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.remainingbprice }}</span>
                                    </template>

                                    <template v-slot:[`item.remainingqty`]="{ item }">
                                        <span class="font-weight-regular caption">{{ item.remainingqty }}</span>
                                    </template>

                                    <template v-slot:[`item.unrealisedpnl`]="{ item }">
                                        <span
                                            :class="{ 'green--text': item.unrealisedpnl > 0, 'red--text': item.unrealisedpnl < 0, 'black--text': item.unrealisedpnl == 0 }"
                                            class="font-weight-regular caption ">{{ item.unrealisedpnl ?
                                                (item.unrealisedpnl).toFixed(2) : 0 }}</span>
                                    </template>
                                    <template v-slot:[`item.realisedpnl`]="{ item }">
                                        <span
                                            :class="{ 'green--text': item.total_realised_pnl > 0, 'red--text': item.total_realised_pnl < 0, 'black--text': item.total_realised_pnl == 0 }"
                                            class="font-weight-regular caption">{{ item.total_realised_pnl ?
                                                (item.total_realised_pnl).toFixed(2) : 0 }}</span>
                                    </template>
                                    <template v-slot:no-data>
                                        <v-col class="mx-auto pa-15 mt-5">
                                            <img alt="" class="shrink" src="../../../assets/nodata.svg" width="15%"
                                                height="" />
                                            <p class="font-weight-bold black--text">No data available</p>
                                        </v-col>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                        </v-tabs-items>

                        <!-- // script wise data  -->



                    </v-card>
                    <!-- :search="search" -->
                    <!-- {{ TableData.length }} -->
                    <!-- <a class="ml-1" href="/pnl" target="_blank">Classic pnl >>>>></a> -->



                </v-col>

            </div>
            <!-- mobile -->
            <div class="d-md-none">
                <v-toolbar class="mt-6 mb-1 px-2  toolbar-contant" elevation="0" color="white">
                    <v-list class="mr-2" style="background-color: transparent;">
                        <v-list-item class="px-0 pt-0 mt-2">
                            <v-list-item-content class=" pt-0">
                                <v-list-item-title class="text-start"
                                            style="color: #000000;font-size: 20px;font-weight:559;line-height:19px;letter-spacing:-1px">
                                            P&L Insights </v-list-item-title>

                                        <v-list-item-subtitle class="text-start pt-1"
                                            style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Straight
                                            to the point about profit and loss analysis.
                                        </v-list-item-subtitle>
                                <!-- <v-list-item-subtitle class="text-start pt-1"
                                    style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Old format
                                    P&L Reference
                                    Available <a href="/pnl">Click here</a>
                                </v-list-item-subtitle> -->
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-spacer></v-spacer>

                    <v-list class=" pt-0" style="background-color: transparent;">
                        <v-list-item class="pl-0 pa-0" style="min-height: 0px;">





                        </v-list-item>

                    </v-list>


                </v-toolbar>
                <v-divider class=" mx-2"></v-divider>
                <v-card color="#eeeeee" outlined class="mx-2 mt-4 d-md-none elevation-0 rounded-lg pa-6">
                    <div class="text-center pa-4">
                        <p class="caption" style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                            Realised P&L</p>
                        <p :class="RealishedPnl > 0 ? 'green--text' : RealishedPnl < 0 ? 'red--text' : 'black--text'"
                            class="mb-0"
                            style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                            {{ (RealishedPnl).toFixed(2) }}
                        </p>
                        <!-- {{ disrealised_pnl }} -->
                    </div>
                    <v-card outlined class="elevation-0 rounded-lg pa-4 pb-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col cols="5">
                                        <p class="caption"
                                            style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                            Unrealised P&L</p>
                                    </v-col>
                                    <v-col cols="7">
                                        <p :class="UnRealishedPnl > 0 ? 'green--text' : UnRealishedPnl < 0 ? 'red--text' : 'black--text'"
                                            class="mb-0 text-right"
                                            style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                            {{ (UnRealishedPnl).toFixed(2) }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-row no-gutters @click="chargerdialoge = true">
                                    <v-col cols="5">
                                        <p class="caption" @click="chargerdialoge = true"
                                            style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                            Charges & taxes</p>
                                    </v-col>
                                    <v-col cols="7">

                                        <!-- <p :class="TaxesAndCharges > 0 ? 'green--text' : TaxesAndCharges < 0 ? 'red--text' : 'black--text'"
                                            class="mb-0 text-right"
                                            style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                            {{ (TaxesAndCharges).toFixed(2) }}
                                        </p> -->
                                        <p class="mb-0 text-right red--text"
                                            style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                            {{ (TaxesAndCharges).toFixed(2) }}
                                        </p>


                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <v-row no-gutters>
                                    <v-col cols="5">
                                        <p class="caption"
                                            style="color: #696969; letter-spacing: 0.16em; text-transform: uppercase; ">
                                            Net Realised P&L</p>
                                    </v-col>
                                    <v-col cols="7">
                                        <p :class="RealishedPnl - TaxesAndCharges > 0 ? 'green--text' : RealishedPnl - TaxesAndCharges < 0 ? 'red--text' : 'black--text'"
                                            class="mb-0 text-right"
                                            style="font-size: 13px; font-weight: 469; line-height: 12px; letter-spacing: 0.9px;">
                                            {{ (RealishedPnl - TaxesAndCharges).toFixed(2) }}
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
                <div class="d-flex mt-4 mb-4">
                    <v-select :disabled="loader" label="Filled" :items="filterr" @change="filterseg('mobile')" dense
                        rounded solo flat v-model="filterdata_unpl" placeholder="filter" background-color="#F1F3F8"
                        hide-details class="mx-4 fildrop" style="max-width: 100%; font-size: 21px">

                        <template v-slot:selection="{ item }">
                            <span class="font-weight-medium caption">{{ item }}</span>
                        </template>
                    </v-select>

                </div>
                <v-menu :disabled="loader" class="" v-model="menuForDatePickerMobile" left
                    :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field style="max-width: 100%;" class="  mx-4" solo rounded flat v-model="fromshow"
                            label="From date" dense color="black" background-color="#F1F3F8"
                            prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-card class="pa-2">
                        <div>
                            <v-date-picker range :min="minval" :max="maxval" color="black" v-model="fromdate"
                                @input="datemaxvalue('click')"></v-date-picker>
                            <!-- <v-date-picker  range color="black" v-model="fromdate" @change="getCalenderData()"></v-date-picker> -->
                        </div>
                        <!-- <p v-if="fromdate != '' && fromdate != [] && highlightyearsValue != 'cur'" class="ml-2 caption mb-1 "><span class="red--text">*</span>Your are in {{Number(maxval.split("-")[0]) - 1}}-{{maxval.split("-")[0]}} Financial year 
                                        <v-tooltip  color="black" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                           <span @click="reset"
                                             class="caption blue--text font-weight-bold"
                                        
                                            style="cursor: pointer"
                                            v-bind="attrs"
                                            v-on="on">
                                            Change
                                           </span>
                                        </template>
                                        <span>Click here to move the date forward for Financial year</span>
                                        </v-tooltip>
                                    </p> -->
                                    <p class="text-right mb-2">
                                        <v-tooltip v-if="fromdate != [] " color="black" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span @click="reset" class="caption blue--text font-weight-bold"
                                        style="cursor: pointer" v-bind="attrs" v-on="on">
                                        Reset
                                    </span>
                                </template>
                                <span>Click here to Resets date</span>
                            </v-tooltip>
                                    </p>
                                    <p 
                            class="ml-2 caption mb-1 text-center">
                            <span class="red--text">*</span>
                            <!-- Your are in {{ Number(maxval.split("-")[0]) -
                                1 }}-{{ maxval.split("-")[0] }} Financial year -->
                                 Here you can only see the current Financial year Data
                                 <br>
                                  <span>Other financial data available in <span  style="cursor: pointer;" class="blue--text" @click="redirecttotax">Tax pnl page  </span> </span>
                            
                        </p>
                        <!-- <v-divider></v-divider>
                        <div class="d-flex mt-n2">
                            <p class="mb-0 mx-1 pa-4 body-2 font-weight-black" style="cursor: pointer;" @click="gettradedataextra(7)">Last 7 days</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"  @click="gettradedataextra(30)">Last 30 days</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                :class="{ 'blue--text': highlightyearsValue == 'cur', 'black--text': highlightyearsValue != 'cur' }"
                                @click="GetDataWithYearSelector(0, 'cur')">Current FY</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                :class="{ 'blue--text': highlightyearsValue == 'lyear', 'black--text': highlightyearsValue != 'lyear' }"
                                @click="GetDataWithYearSelector(-1, 'lyear')">Last FY</p>

                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                :class="{ 'blue--text': highlightyearsValue == yearsarray[0], 'black--text': highlightyearsValue != yearsarray[0] }"
                                @click="GetDataWithYearSelector(-2, yearsarray[0])">{{ yearsarray[0] }}</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                :class="{ 'blue--text': highlightyearsValue == yearsarray[1], 'black--text': highlightyearsValue != yearsarray[1] }"
                                @click="GetDataWithYearSelector(-3, yearsarray[1])">{{ yearsarray[1] }}</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" style="cursor: pointer;"
                                :class="{ 'blue--text': highlightyearsValue == yearsarray[2], 'black--text': highlightyearsValue != yearsarray[2] }"
                                @click="GetDataWithYearSelector(-4, yearsarray[2])">{{ yearsarray[2] }}</p>
                            <p class="mb-0 pl-0  pa-4 body-2 font-weight-black" @click="mountedfun(30)">Last </p>
                        </div> -->
                    </v-card>

                </v-menu>
                <!-- P&L verified by Zebu -->
                <div v-if="TableData.length > 0" class="d-flex row  ml-5 mb-2">
                    <p class=" mb-3 mt-8" style="
                        font-weight: 450;
                        font-size: 14px;
                        color: #4b4b4b;
                        line-height: 16px;
                        letter-spacing: -0.4px;
                      ">
                        <v-icon size="16" color="green" class="pt-n2">mdi mdi-check-circle</v-icon>
                        P&L verified by Zebu 
                        
                    </p>
                    <div class="ml-auto">
                        <p class="mt-2 mr-7 mb-0 " style="font-size: 12px">Share to Everyone</p>
                        <div class="d-flex">
                            <v-switch color="black" @change="switchbtn" class="mt-1" v-model="agreeforshare" inset
                                dense></v-switch>
                            <v-btn class="mt-2 px-3" disabled rounded x-small v-if="!agreeforshare">
                                <v-icon class="" size="16">mdi mdi-share-variant</v-icon>
                            </v-btn>
                            <v-btn dark class="mt-2 px-3" rounded x-small v-else @click="sharetomobile">
                                <v-icon color="white" class="" size="16">mdi mdi-share-variant</v-icon>
                            </v-btn>

                        </div>
                    </div>
                </div>
                <v-col cols="12" class="pa-0">


                    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                        <v-tab>
                            Daily
                        </v-tab>
                        <v-tab>
                            Monthly
                        </v-tab>
                    </v-tabs>

                </v-col>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card class="" outlined style=" height : 260px; overflow-x: scroll;">
                            <div v-if="ChartValue.length > 0 && loader == false" class="pa-5">
                                <!-- <div id="cal-heatmap"></div> -->

                                <div class="ml-1" id="cal-heatmap2"></div>

                            </div>
                            <div v-else-if="loader == false" class="text-center mt-4">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="50%" height="" />
                                <p class="mb-0 caption mt-2">No data available</p>
                            </div>
                            <!-- <v-overlay v-else class="rounded-0" style="z-index:2000"> -->
                            <div v-if="loader == true" class="text-center mt-6">
                                <v-progress-circular :size="50" :width="4" color="#0037B7"
                                    indeterminate></v-progress-circular>
                                <p class="mb-0 caption mt-4">Getting your data please wait...</p>
                            </div>
                            <!-- </v-overlay> -->
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card class="pl-4 pr-4" outlined style=" height : 125px;width : 100%;overflow-x: scroll">
                            <div v-if="loader == false" class="ml-n3 mt-4 d-flex">
                                <!-- <div id="cal-heatmap"></div> -->

                                <div class="d-flex pl-12" style="width: 100%;">
                                    <v-card v-for="(key, val, ind) in calendermontharray" :key="ind" outlined
                                        class="ma-2 mr-3 my-4 elevation-0" style="min-width:  100px;  "
                                        :style="{ backgroundColor: Number(key.value) < 0 ? '#ffd4d4' : Number(key.value) > 0 ? '#cdfad1' : '#ededed' }">



                                        <p :style="{ color: Number(val[0].value) == 0 ? 'black' : 'black' }"
                                            class="mb-0 caption pl-2 pt-1 pr-2" style="width: ">
                                            {{ val.substring(0, 3) }} {{
                                                val == 'January' || val
                                                    == 'February' || val == 'March' ? ToDateForApi.split("/")[2] :
                                                    FromDateForApi.split("/")[2] }} <br>{{

                                                (key.value).toFixed(2)
                                            }}</p>
                                        <!-- <p :style="{ color: Number(val[0].value) == 0 ? 'black' : 'black' }"
                                                class="mb-0 caption pl-2 pt-1 pr-2" style="width: 100px;">{{
                                                    val[0].value.toFixed(2) }} </p> -->


                                    </v-card>
                                </div>

                            </div>
                            <!-- <div v-else-if="loader == false" class="text-center mt-4">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="8%" height="" />
                                <p class="mb-0 caption mt-2">No data available</p>   
                            </div> -->
                            <!-- <v-overlay v-else class="rounded-0" style="z-index:2000"> -->
                            <div v-else class="text-center mt-4">
                                <v-progress-circular :size="50" :width="4" color="#0037B7"
                                    indeterminate></v-progress-circular>
                                <p class="mb-0 caption mt-4">Getting your data please wait...</p>
                            </div>
                            <!-- </v-overlay> -->
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>
                <!-- <v-card class="" outlined style=" height : 260px; overflow-x: scroll;">
                    <div v-if="ChartValue.length > 0 && loader == false" class="pa-5">
                      

                        <div class="ml-1" id="cal-heatmap2"></div>

                    </div>
                    <div v-else-if="loader == false" class="text-center mt-4">
                        <img alt="" class="shrink" src="../../../assets/nodata.svg" width="8%" height="" />
                        <p class="mb-0 caption mt-2">No data available</p>
                    </div>
                     
                    <div v-if="loader == true" class="text-center mt-6">
                        <v-progress-circular :size="50" :width="4" color="#0037B7" indeterminate></v-progress-circular>
                        <p class="mb-0 caption mt-4">Getting your data please wait...</p>
                    </div>
                    
                </v-card> -->
                <v-col cols="12" class="pa-0">


                    <v-tabs v-model="tab2" background-color="transparent" color="basil" grow>
                        <v-tab>
                            Date Wise
                        </v-tab>
                        <v-tab>
                            Script Wise
                        </v-tab>
                    </v-tabs>

                </v-col>
                <v-tabs-items v-model="tab2">
                    <v-tab-item>
                        <v-expansion-panels inset style="z-index: 0">
                            <v-expansion-panel v-for="(item, i) in DateTableData" :key="i">
                                <v-expansion-panel-header>{{ formatDate(item.name) }} ({{ item.val.length }}) <span
                                        class="overline text-right" :class="{
                                            'green--text': realisedcal(item.val) > 0,
                                            'red--text': realisedcal(item.val) < 0,
                                            'black--text': realisedcal(item.val) === 0
                                        }"> {{ realisedcal(item.val) }}</span> </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card v-for="iitem in item.val" :key="iitem.index"
                                        style="border-top: 5px #F1F3F8 solid;" class="elevation-0  px-4 pt-2"
                                        width="100%">

                                        <span class="font-weight-bold">

                                            {{ iitem.SCRIP_SYMBOL }}
                                            <v-chip v-if="iitem.Open_Qty" class="ma-2" small color="green" outlined> {{
                                                iitem.Open_Qty }} @ {{ iitem.Open_Rate }} </v-chip>

                                            <!-- {{ item.COMPANY_CODE }} -->
                                            <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                                        </span>
                                        <v-divider class="mb-2 mt-2"></v-divider>
                                        <v-row class="px-2">
                                            <v-col>
                                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net
                                                    Qty
                                                </p>
                                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy
                                                    Qty:
                                                    <span class="mb-0 body-2 font-weight-regular"
                                                        style="color: #000000;">{{
                                                            iitem.BQTY ? iitem.BQTY : '-'
                                                        }}</span>
                                                </p>
                                                <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Buy
                                                    Rate :
                                                    <span class="mb-0 body-2 font-weight-regular"
                                                        style="color: #000000;">{{
                                                            iitem.BRATE ? iitem.BRATE : '-'
                                                        }}</span>
                                                </p>
                                            </v-col>
                                            <v-col class="text-end">
                                                <p v-if="iitem.Updated_NETQTY > 0"
                                                    class="mb-0 body-2 font-weight-regular" style="color: green;">{{
                                                        iitem.Updated_NETQTY }}</p>
                                                <p v-if="iitem.Updated_NETQTY < 0"
                                                    class="mb-0 body-2 font-weight-regular" style="color: red;">
                                                    {{
                                                        iitem.Updated_NETQTY }}</p>
                                                <p v-if="iitem.Updated_NETQTY == 0"
                                                    class="mb-0 body-2 font-weight-regular" style="color: #000000;">
                                                    {{ iitem.Updated_NETQTY }}</p>

                                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell
                                                    Quantity: <span class="mb-0 body-2 font-weight-regular"
                                                        style="color: #000000;">{{
                                                            iitem.SQTY ? iitem.SQTY : '-' }}

                                                    </span>
                                                </p>
                                                <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Sell
                                                    Rate :
                                                    <span class="mb-0 body-2 font-weight-regular"
                                                        style="color: #000000;">{{
                                                            iitem.SRATE ? iitem.SRATE : '-'
                                                        }}</span>
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card v-for="item in TableData" :key="item.index" style="border-top: 5px #F1F3F8 solid;"
                            class="elevation-0  px-4 pt-2" width="100%">

                            <div class="d-flex ">
                                <span @click="SymbolMatchedDate(item, 'mobile')" class="font-weight-bold">

                                    {{ item.SCRIP_SYMBOL }}

                                    <!-- {{ item.COMPANY_CODE }} -->
                                    <!-- <span class="caption font-weight-medium">({{
                            desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                                </span>



                            </div>


                            <v-divider class="mb-2 mt-2"></v-divider>
                            <v-row class="px-2">
                                <v-col>
                                    <p class="mb-1 ml-auto d-flex body-2 font-weight-regular" style="color: #666666;">
                                        Net Qty:
                                        <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.Updated_NETQTY
                                        }}</span>
                                    </p>
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Amt: <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{

                                                (item.total_buy_rate * item.total_buy_qty).toFixed(4)

                                            }}</span>
                                    </p>
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                                item.total_buy_qty
                                            }}</span>
                                    </p>
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                                item.total_buy_rate.toFixed(4)
                                            }}</span>
                                    </p>

                                </v-col>
                                <v-col class="text-end">
                                    <!-- <p class="mb-1 ml-auto body-2 font-weight-regular" style="color: #666666;">Net Avg: <span
                                    class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                        item.BUY_QUANTITY
                                    }}</span>
                            </p> -->
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Amt: <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                                (item.total_sell_rate * item.total_sell_qty).toFixed(4)
                                            }}</span>
                                    </p>
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Qty: <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                                item.total_sell_qty
                                            }}</span>
                                    </p>
                                    <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                                            class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                                item.total_sell_rate.toFixed(4)
                                            }}</span>
                                    </p>
                                    <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Realised Pnl :
                                        <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.realisedpnl
                                        }}</span>
                                    </p>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>

            </div>


            <!-- dialogue -->
            <v-bottom-sheet v-model="sheetforshare" inset>
                <v-sheet class="text-center" height="200px">
                    <v-card class="elevation-0">
                        <v-list-item-content class=" pt-5 pl-5">
                            <v-list-item-title class="text-start"
                                style="color: #000000;font-size: 18px;font-weight:559;line-height:24px;letter-spacing:-1px">Grab
                                your URL
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-start pt-1"
                                style="color: #666666;font-size: 11px;font-weight:469;line-height:14px"> Click to share
                                your
                                triumphant
                                journey.
                            </v-list-item-subtitle>

                        </v-list-item-content>
                        <v-divider></v-divider>

                        <div class="px-6 mt-3 mb-2">
                            <p class="mb-1 caption">Share this link Or copy link</p>

                        </div>
                        <!-- <p class="mb-1 px-6 caption">Or copy link</p> -->
                        <div class="d-flex">

                            <v-text-field readonly label="Regular" solo rounded flat dense background-color="#F1F3F8"
                                v-model="copytext" style="width: 60px" class="  ml-6" height="36px"></v-text-field>
                            <v-btn @click="copyTextclick" class="ml-2  text-capitalize white--text" solo text rounded
                                flat dense style="background-color: black;"><v-icon size="18">mdi
                                    mdi-content-copy</v-icon></v-btn>
                            <v-btn @click="shareTweet" class="mr-5 ml-2 text-capitalize white--text" solo text rounded
                                flat dense style="background-color: black;"><img src="@/assets/xmark.svg" width="12px"
                                    class="ml-1" alt="Portfolio icon" /></v-btn>


                        </div>

                    </v-card>

                </v-sheet>
            </v-bottom-sheet>

            <v-dialog v-model="dialogForSymDetails" width="80%">

                <v-card height="600px" width="100%">
                    <v-toolbar class=" mb-1 px-1 toolbar-contant" elevation="0" color="white">
                        <v-list class="mr-2" style="background-color: transparent;">
                            <v-list-item class="px-0 pt-4">
                                <v-list-item-content class=" pt-0">
                                    <v-list-item-title class="text-start"
                                        style="color: #000000;font-size: 20px;font-weight:559;line-height:19px;letter-spacing:-1px">
                                        {{ monthval.month ? `${monthval.month} Month Data` : 'P&L Insights' }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle class="text-start "
                                        style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">
                                        Straight to the point about profit and loss analysis.
                                    </v-list-item-subtitle>

                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialogForSymDetails = false"><v-icon>mdi mdi-close</v-icon></v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-data-table ref="dataTableRef" mobile-breakpoint hide-default-footer height="520px" fixed-header
                        disable-sort :headers="HeaderFortable" :items="SymbolDataMatchedTableArray"
                        :items-per-page="SymbolDataMatchedTableArray.length"
                        style="  border: 1px solid #EFEEF3;z-index: -1;" class="elevation-0 rounded-lg ">


                        <template v-slot:[`item.SCRIP_SYMBOL`]="{ item }">
                            <span class="font-weight-bold caption">{{ item.SCRIP_SYMBOL }}</span>
                            <!-- <p class="font-weight-normal mb-0 caption">{{ item.TRADE_DATE.split(" ")[1] + "/" +
                                item.TRADE_DATE.split(" ")[2] + "/" + item.TRADE_DATE.split(" ")[3] }}</p> -->
                                <!-- <p class="font-weight-normal mb-0 caption">{{ (item.TRADE_DATE).split("T")[0].split(" ")[1] + "/" +
                                (item.TRADE_DATE).split("T")[0].split(" ")[2] + "/" + (item.TRADE_DATE).split("T")[0].split(" ")[3] }}</p> -->
                                <p class="font-weight-normal mb-0 caption">{{  (item.TRADE_DATE.split("T")[0]).split("-")[2] + "/" + (item.TRADE_DATE.split("T")[0]).split("-")[1]+ "/" +(item.TRADE_DATE.split("T")[0]).split("-")[0]  }}</p>
                        </template>

                        <template v-slot:[`item.CLOSING_PRICE`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.CLOSING_PRICE }}</span>
                        </template>

                        <!-- <template v-slot:[`item.BAMT`]="{ item }">
                                    <span class="font-weight-regular caption">{{ item.BAMT ? (item.BAMT).toFixed(2) : 0 }}</span>
                                </template> -->

                        <template v-slot:[`item.total_buy_qty`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.BQTY }}</span>
                        </template>

                        <template v-slot:[`item.total_buy_rate`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.BRATE ? (item.BRATE).toFixed(4) : 0
                                }}</span>
                            <p class="font-weight-regular caption mb-0">{{ item.BRATE ? (item.BQTY *
                                item.BRATE).toFixed(4) : 0 }}
                            </p>
                        </template>

                        <!-- <template v-slot:[`item.SAMT`]="{ item }">
                                    <span class="font-weight-regular caption">{{ item.SAMT ? (item.SAMT).toFixed(2) : 0 }}</span>
                                </template> -->

                        <template v-slot:[`item.total_sell_qty`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.SQTY }}</span>
                        </template>

                        <template v-slot:[`item.total_sell_rate`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.SRATE ? (item.SRATE) : 0 }}</span>
                            <p class="font-weight-regular caption mb-0">{{ item.SAMT ? (item.SAMT).toFixed(4) : 0 }}</p>

                        </template>
                        <template v-slot:[`item.Updated_NETQTY`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.Updated_NETQTY }}</span>
                            <p v-if="item.Updated_NETQTY != 0" class="font-weight-regular caption mb-0">{{
                                item.NRATE.toFixed(4) }}
                            </p>
                        </template>
                        <template v-slot:[`item.remainingbprice`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.remainingbprice }}</span>
                        </template>

                        <template v-slot:[`item.remainingqty`]="{ item }">
                            <span class="font-weight-regular caption">{{ item.remainingqty }}</span>
                        </template>

                        <template v-slot:[`item.unrealisedpnl`]="{ item }">
                            <span
                                :class="{ 'green--text': item.unrealisedpnl > 0, 'red--text': item.unrealisedpnl < 0, 'black--text': item.unrealisedpnl == 0 }"
                                class="font-weight-regular caption ">{{ item.unrealisedpnl ?
                                    (item.unrealisedpnl).toFixed(2) : 0 }}</span>
                        </template>
                        <template v-slot:[`item.realisedpnl`]="{ item }">
                            <span
                                :class="{ 'green--text': item.realisedpnl > 0, 'red--text': item.realisedpnl < 0, 'black--text': item.realisedpnl == 0 }"
                                class="font-weight-regular caption">{{ item.realisedpnl ? (item.realisedpnl).toFixed(2)
                                    : 0
                                }}</span>
                        </template>
                        <template v-slot:no-data>
                            <v-col class="mx-auto pa-15">
                                <img alt="" class="shrink" src="../../../assets/nodata.svg" width="8%" height="" />
                                <p class="font-weight-bold black--text">No data available</p>
                            </v-col>
                        </template>
                    </v-data-table>
                </v-card>
            </v-dialog>
            <v-bottom-sheet v-model="dialogForSymDetailsMobile" height="600px">

                <v-card height="600px">
                    <v-toolbar class=" mb-1 px-2  toolbar-contant" elevation="0" color="white">
                        <v-list class="pb-0" style="background-color: transparent;">
                            <v-list-item class=" pt-0 px-0">

                                <v-list-item-content class=" pt-0 mt-2">
                                    <v-list-item-title class="text-start"
                                            style="color: #000000;font-size: 20px;font-weight:559;line-height:19px;letter-spacing:-1px">
                                            P&L Insights </v-list-item-title>

                                        <v-list-item-subtitle class="text-start pt-1"
                                            style="color: #666666;font-size: 12px;font-weight:469;line-height:14px">Straight
                                            to the point about profit and loss analysis.
                                        </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-spacer></v-spacer>

                        <v-list class=" pt-0" style="background-color: transparent;">
                            <v-list-item class="pl-0 pa-0" style="min-height: 0px;">





                            </v-list-item>

                        </v-list>


                    </v-toolbar>
                    <v-divider class=" mx-2"></v-divider>
                    <v-card v-for="item in SymbolDataMatchedTableArray" :key="item.index"
                        style="border-top: 5px #F1F3F8 solid;" class="elevation-0  px-4 pt-2" width="100%">

                        <div class="d-flex ">
                            <span class="font-weight-bold">

                                {{ item.SCRIP_SYMBOL }}

                                <!-- {{ item.COMPANY_CODE }} -->
                                <!-- <span class="caption font-weight-medium">({{
                            desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                            </span>
                            <p class="font-weight-normal mb-0 ml-2 caption">

                                {{  (item.TRADE_DATE.split("T")[0]).split("-")[2] + "/" + (item.TRADE_DATE.split("T")[0]).split("-")[1]+ "/" +(item.TRADE_DATE.split("T")[0]).split("-")[0] }}

                                <!-- {{ item.COMPANY_CODE }} -->
                                <!-- <span class="caption font-weight-medium">({{
desserts2[item.SCRIP_SYMBOL].length }})</span> -->
                            </p>



                        </div>


                        <v-divider class="mb-2 mt-2"></v-divider>
                        <v-row class="px-2">
                            <v-col>
                                <p class="mb-1 ml-auto d-flex body-2 font-weight-regular" style="color: #666666;">Net
                                    Qty: <span class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                        item.Updated_NETQTY
                                        }}</span></p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Amt: <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.BAMT
                                        }}</span>
                                </p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Qty: <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.total_buy_qty
                                        }}</span>
                                </p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Buy Rate : <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.total_buy_rate
                                        }}</span>
                                </p>
                                <p class="mb-3 body-2 font-weight-regular" style="color: #666666;">Realised Pnl : <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.realisedpnl
                                        }}</span>
                                </p>
                            </v-col>
                            <v-col class="text-end">
                                <!-- <p class="mb-1 ml-auto body-2 font-weight-regular" style="color: #666666;">Net Avg: <span
                                    class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                        item.BUY_QUANTITY
                                    }}</span>
                            </p> -->
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Net Rate : <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.NRATE.toFixed(4)

                                        }}</span>
                                </p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Amt: <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.SAMT
                                        }}</span>
                                </p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Qty: <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.total_sell_qty
                                        }}</span>
                                </p>
                                <p class="mb-1 body-2 font-weight-regular" style="color: #666666;">Sell Rate : <span
                                        class="mb-0 body-2 font-weight-regular" style="color: #000000;">{{
                                            item.total_sell_rate
                                        }}</span>
                                </p>


                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </v-bottom-sheet>
        </v-container>
        <v-dialog v-model="dialogcopytext" width="500">


            <v-card>
                <v-list-item-content class=" pt-5 pl-5">
                    <v-list-item-title class="text-start"
                        style="color: #000000;font-size: 18px;font-weight:559;line-height:24px;letter-spacing:-1px">Grab
                        your URL
                    </v-list-item-title>

                    <v-list-item-subtitle class="text-start pt-1"
                        style="color: #666666;font-size: 11px;font-weight:469;line-height:14px"> Click to share your
                        triumphant
                        journey.
                    </v-list-item-subtitle>
                    <v-btn absolute right top icon color="black" @click="dialogcopytext = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-list-item-content>
                <v-divider></v-divider>

                <div class="px-6 mt-3 mb-2">
                    <p class="mb-1 caption">Share this link Or copy link</p>

                </div>
                <!-- <p class="mb-1 px-6 caption">Or copy link</p> -->
                <div class="d-flex">

                    <v-text-field readonly label="Regular" solo rounded flat dense background-color="#F1F3F8"
                        v-model="copytext" style="width: 60px" class="  ml-6" height="36px"></v-text-field>
                    <v-btn @click="copyTextclick" class="ml-2  text-capitalize white--text" solo text rounded flat dense
                        style="background-color: black;"><v-icon size="18">mdi mdi-content-copy</v-icon></v-btn>
                    <v-btn @click="shareTweet" class="mr-5 ml-2 text-capitalize white--text" solo text rounded flat
                        dense style="background-color: black;"><img src="@/assets/xmark.svg" width="12px" class="ml-1"
                            alt="Portfolio icon" /></v-btn>


                </div>

            </v-card>

        </v-dialog>

    </v-app>
</template>

<script>
import CalHeatmap from 'cal-heatmap';
import Tooltip from 'cal-heatmap/plugins/Tooltip';
import 'cal-heatmap/cal-heatmap.css';
import { apiurl } from '../../../Api.js'
import { apidailypnl } from "../../../Api.js";

// import { apiurl } from '../../../Api.js'
// import LegendLite from 'cal-heatmap/plugins/LegendLite';
import CalendarLabel from 'cal-heatmap/plugins/CalendarLabel';
export default {
    name: 'HeatmapComponent',
    data() {
        return {
            ChartValue: [],
            tab: null,

            fromshow: '',
            filterdata_unpl: 'Equity',
            agreeforshare: false,
            yearsarray: [],
            cal: null,
            sheetforshare: false,
            shareresdata: [],
            uniqueCode: false,
            highlightyearsValue: 'cur',
            dialogForSymDetails: false,
            dialogForSymDetailsMobile: false,
            dialogcopytext: false,
            TableDataForMonth: [],
            fromdate: [],
            maxval: '',
            postalready: null,
            menuForDatePicker: false,
            menuForDatePickerMobile: false,
            postalreadystats: '',
            monthval: {},
            HeaderFortableForexpand: [
                {
                    text: 'Symbol',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                    width: '28%'

                },
                { text: 'Buy Qty', value: '', align: 'right', width: '9%' },
                { text: 'Buy Rate', value: '', width: '9%', align: 'right' },
                { text: 'Sell Qty', value: '', width: '9%', align: 'right' },
                { text: 'Sell Rate', value: '', width: '9%', align: 'right' },
                { text: 'Net Qty', value: '', width: '9%', align: 'right' },
                // { text: 'Net Rate', value: '', width: '9%', align: 'right' },
                { text: 'Close price', value: '', width: '9%', align: 'right' },
                { text: 'last', value: 'count', width: '15%', align: 'right' },
                { text: '', value: 'data-table-expand' },
                { text: 'Realised P&L', value: 'real', width: '15%', align: 'right' },

            ],
            resetrange : '',
            resetrangemin : '',
            HeaderFortableForexpandinSide: [
                {
                    text: 'Symbol',
                    align: 'start',
                    sortable: false,
                    value: 'SCRIP_SYMBOL',

                },
                { text: 'Buy Qty', value: 'BQTY', align: 'right', },
                { text: 'Buy Rate', value: 'BRATE', align: 'right' },
                { text: 'Sell Qty', value: 'SQTY', align: 'right' },
                { text: 'Sell Rate', value: 'SRATE', align: 'right' },
                { text: 'Net Qty', value: 'Updated_NETQTY', align: 'right' },
                // { text: 'Net Rate', value: '', width: '9%', align: 'right' },
                { text: 'Close price', value: 'CLOSING_PRICE', align: 'right' },
                { text: 'Realised P&L', value: 'realisedpnl', align: 'right' },
                // { text: 'last', value: 'last',  align: 'right' },
            ],
            monthArray: [
                { month: "Apr", value: 0 },
                { month: "May", value: 0 },
                { month: "Jun", value: 0 },
                { month: "Jul", value: 0 },
                { month: "Aug", value: 0 },
                { month: "Sep", value: 0 },
                { month: "Oct", value: 0 },
                { month: "Nov", value: 0 },

                { month: "Dec", value: 0 },
                { month: "Jan", value: 0 },
                { month: "Feb", value: 0 },
                { month: "Mar", value: 0 },
            ],

            TaxesAndCharges: 0,
            UnRealishedPnl: 0,
            DateTableData: [],

            RealishedPnl: 0,
            tab2: null,
            FromDateForApi: '',
            copytext: '',
            ToDateForApi: '',
            susertoken: '',
            actid: '',
            cname: '',
            minval: '',
            loader: true,
            coloralert: '',
            calendermontharray: [],

            alert: false,
            rangeColr: ['#ff6e6e', '#5aae61'],
            rangeValue: [-0.01, 0.01],
            Nodata: false,
            msg: '',
            expanded: [],

            singleExpand: true,
            HeaderFortable: [
                { text: 'Script Symbol', value: 'SCRIP_SYMBOL', align: 'start', class: "headerfont", width: '250px' },
                { text: 'Buy qty', value: 'total_buy_qty', align: 'right', class: "headerfont" },
                // { text: 'Date', value: 'TRADE_DATEDt' , align: 'start', class: "headerfont",width : '100px' },
                // { text: 'BAMT', value: 'BAMT' , align: 'start', class: "headerfont" },
                { text: 'Buy rate', value: 'total_buy_rate', align: 'right', class: "headerfont" },
                { text: 'Sell qty', value: 'total_sell_qty', align: 'right', class: "headerfont" },
                // { text: 'SAMT', value: 'SAMT' , align: 'start', class: "headerfont" },
                { text: 'Sell rate', value: 'total_sell_rate', align: 'right', class: "headerfont" },
                { text: 'Net Qty', value: 'Updated_NETQTY', align: 'right', class: "headerfont" },
                { text: 'Close Price', value: 'CLOSING_PRICE', align: 'right', class: "headerfont" },
                // { text: 'Unrealisedpnl', value: 'unrealisedpnl', align: 'right', class: "headerfont" },
                { text: 'Realisedpnl', value: 'realisedpnl', align: 'right', class: "headerfont" },
                // { text: 'last', value: 'last', align: 'right', class: "headerfont" },
                // { text: 'pnl', value: 'unrealisedpnl' , align: 'start', class: "headerfont" },
            ],
            search: null,
            HeaderForMonthtable: [

                { text: 'Month', value: 'month', align: 'start', class: "headerfont" },
                { text: 'No of trades', value: 'trades', align: 'right', class: "headerfont" },
                { text: 'Realisedpnl', value: 'value', align: 'right', class: "headerfont" },
                // { text: 'pnl', value: 'unrealisedpnl' , align: 'start', class: "headerfont" },
            ],
            TableData: [],
            // filterr: ['All', 'Equity', 'Fno', 'Commodity', 'Currency'],
            filterr: ['Equity', 'Fno', 'Commodity', 'Currency'],
            SymbolDataMatched: [],
            SymbolDataMatchedTableArray: [],
            StatArray: [],
            username: '',
            // agreeforshare: false,
        };
    },
    methods: {
        redirecttotax(){
                              this.$router.push("/taxpnl");

        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        toggleExpanded(item) {
            // console.log("fgfg", item)
            const index = this.expanded.indexOf(item);
            if (index === -1) {
                this.expanded = this.singleExpand ? [item] : [...this.expanded, item];
            } else {
                this.expanded = this.expanded.filter((el) => el !== item);
            }
        },
        realisedcal(item) {
            // console.log(item);

            var val = 0
            for (let i = 0; i < item.length; i++) {
                const element = item[i];
                val += element.realisedpnl
            }
            return val.toFixed(2)
        },
        sharetomobile() {
            // alert('kjghkjh')
            this.sheetforshare = true
        },
        copyTextclick() {
            navigator.clipboard.writeText(this.copytext);
            this.dialogcopytext = false
            this.sheetforshare = false
            this.alert = true,
                this.coloralert = 'success'
            this.msg = 'URL Copied'

            setTimeout(() => {
                this.alert = false,
                    this.msg = ''

            }, 3000);
        },
        switchbtn() {
            // alert('jhvh')
            // this.agreeforshare = !this.agreeforshare
            //console.log(this.agreeforshare);
            if (this.agreeforshare == true) {
                // console.log(this.postalready, this.agreeforshare);

                if (this.postalready == false) {
                    // console.log('cond 1');
                    // if (this.filterdata_unpl == 'Equity') {
                    //     var SegmentValue = 'NSE_CASH,BSE_CASH'
                    // } else if (this.filterdata_unpl == 'Fno') {
                    //     SegmentValue = 'NSE_FNO,BSE_FNO'
                    // } else if (this.filterdata_unpl == 'Commodity') {
                    //     SegmentValue = 'MCX,NCDEX,NSE_COM,BSE_COM'
                    // } else if (this.filterdata_unpl == 'Currency') {
                    //     SegmentValue = 'CD_NSE,CD_BSE,CD_MCX,CD_USE'
                    // } else if (this.filterdata_unpl == 'All') {
                    //     SegmentValue = 'NSE_CASH,BSE_CASH,NSE_FNO,BSE_FNO,MCX,NCDEX,NSE_COM,BSE_COM,CD_NSE,CD_BSE,CD_MCX,CD_USE'
                    // }
                    // this.postalreadyucode = ''
                    const axios = require('axios');
                    let data = JSON.stringify({
                        "cc": this.actid,
                        "from": this.fromshow.split("_to_")[0],
                        "to": this.fromshow.split("_to_")[1],
                        "sharing": this.agreeforshare,
                        "response": this.shareresdata,
                        "Unique_Code": "",
                        "uname": this.username,
                        "segment": this.filterdata_unpl

                    });
                    let axiosthis = this
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        // url: 'http://192.168.5.198:5050/sharenew',
                        url: `${apiurl}/sharenew`,

                        headers: {
                            'Content-Type': 'application/json',
                            'clientid': this.actid,
                            'Authorization': this.susertoken
                        },
                        data: data
                    };
                    axios.request(config)
                        .then((response) => {
                            // //console.log(JSON.stringify(response.data));
                            let res = response.data.data.uq_code ? response.data.data : []
                            // console.log(response.data.data[0].uq_code);

                            let val = res.uq_code
                            //console.log(val);
                            axiosthis.postalreadyucode = val
                            axiosthis.uniqueCode = val
                            axiosthis.postalready = true
                            // https://reports-cf9df.web.app/Profit_Loss?uid=${actid}&token=${susertoken}"

                            axiosthis.copytext = `${apidailypnl}/dailypnl?ucode=${axiosthis.postalreadyucode}`
                            // axiosthis.copytext = `http://localhost:8080/dailypnl?ucode=${axiosthis.postalreadyucode}`
                            // axiosthis.copytext = `http://192.168.5.117:8080/dailypnl?ucode=${axiosthis.postalreadyucode}`

                        })
                        .catch((error) => {
                            console.log(error);
                            if (error.message == 'Network Error') {
                                axiosthis.msg = error.message
                                axiosthis.loader = false
                                axiosthis.alert = true
                                axiosthis.coloralert = 'error'
                                axiosthis.agreeforshare = false
                                setTimeout(() => {
                                    axiosthis.alert = false
                                    this.msg = ''
                                }, 5000);
                                // alert(error.message)
                            }
                        });
                } else if (this.postalready == true) {
                    // console.log('cond 2');

                    const axios = require('axios');
                    let data = JSON.stringify({
                        "cc": '',
                        "from": '',
                        "to": '',
                        "sharing": this.agreeforshare,
                        "response": '',
                        "Unique_Code": this.postalreadyucode,
                        "uname": '',
                        "segment": ''

                    });
                    let axiosthis = this
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        // url: 'http://192.168.5.198:5050/sharenew',
                        url: `${apiurl}/sharenew`,

                        headers: {
                            'Content-Type': 'application/json',
                            'clientid': this.actid,
                            'Authorization': this.susertoken
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            // //console.log(JSON.stringify(response.data));
                            let res = response.data.data.uq_code ? response.data.data : []

                            let val = res.uq_code
                            //console.log(val);
                            axiosthis.postalreadyucode = val
                            axiosthis.uniqueCode = val
                            // axiosthis.uniqueCode = val
                            // // https://reports-cf9df.web.app/Profit_Loss?uid=${actid}&token=${susertoken}"

                            // axiosthis.copytext = `http://localhost:8080/dailypnl?ucode=${axiosthis.uniqueCode}`
                            // // axiosthis.copytext = `https://report.mynt.in/dailypnl?ucode=${axiosthis.uniqueCode}`
                        })
                        .catch((error) => {
                            console.log(error);
                            if (error.message == 'Network Error') {
                                this.msg = error.message
                                axiosthis.loader = false
                                axiosthis.alert = true
                                axiosthis.coloralert = 'error'

                                this.agreeforshare = false
                                setTimeout(() => {
                                    axiosthis.alert = false
                                    this.msg = ''
                                }, 5000);
                                // alert(error.message)
                            }
                        });
                }


            } else if (this.agreeforshare == false) {
                // console.log('cond 3');

                const axios = require('axios');
                let data = JSON.stringify({
                    "cc": '',
                    "from": '',
                    "to": '',
                    "sharing": this.agreeforshare,
                    "response": '',
                    "Unique_Code": this.postalreadyucode,
                    "uname": '',
                    "segment": ''


                });
                let axiosthis = this
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    // url: 'http://192.168.5.198:5050/sharenew',
                    url: `${apiurl}/sharenew`,

                    headers: {
                        'Content-Type': 'application/json',
                        'clientid': this.actid,
                        'Authorization': this.susertoken
                    },
                    data: data
                };

                axios.request(config)
                    .then((response) => {
                        // //console.log(JSON.stringify(response.data));
                        let res = response.data.data.uq_code ? response.data.data : []

                        let val = res.uq_code
                        //console.log(val);
                        axiosthis.postalreadyucode = val
                        axiosthis.uniqueCode = val
                        // // https://reports-cf9df.web.app/Profit_Loss?uid=${actid}&token=${susertoken}"

                        // axiosthis.copytext = `http://localhost:8080/dailypnl?ucode=${axiosthis.uniqueCode}`
                        // // axiosthis.copytext = `https://report.mynt.in/dailypnl?ucode=${axiosthis.uniqueCode}`
                    })
                    .catch((error) => {
                        console.log(error);
                        if (error.message == 'Network Error') {
                            this.msg = error.message
                            axiosthis.loader = false
                            axiosthis.alert = true
                            axiosthis.coloralert = 'error'

                            this.agreeforshare = false
                            setTimeout(() => {
                                axiosthis.alert = false
                                this.msg = ''
                            }, 5000);
                            // alert(error.message)
                        }
                    });

            }
        },
        shareTweet() {
            //console.log("Custom action: Tweet button clicked!");

            //   const twitterIntentUrl = "https://twitter.com/intent/tweet?text=custom+share+text&hashtags=example,demo&via=twitterdev&related=twitterapi,twitter";
            //   window.open(twitterIntentUrl, '_blank');
            const tweetUrl = "https://twitter.com/intent/tweet";
            // let urlfortweet = 'https://report.mynt.in/dailypnl?ucode=' + this.postalreadyucode
            let urlfortweet = 'http://profile.mynt.in/dailypnl?ucode=' + this.postalreadyucode
            const tweetParams = {
                // url : `https://report.mynt.in/dailypnl?ucode=${axiosthis.uniqueCode}`
                // url: "https://zebuetrade.com/",
                text: "Excited about my recent trading triumph using Zebu—profits surging! Skillful moves on the Zebu app have significantly boosted my success",
                hashtags: "Traders",
                via: "zebuetrade",
                related: "twitterapi,twitter",
                // url : `http://localhost:8080/dailypnl?ucode=${this.uniqueCode}`,
                url: urlfortweet,

                media:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Instagram_logo_2022.svg/1200px-Instagram_logo_2022.svg.png",
            };

            const queryString = Object.keys(tweetParams)
                .map(
                    (key) =>
                        encodeURIComponent(key) + "=" + encodeURIComponent(tweetParams[key])
                )
                .join("&");

            window.open(`${tweetUrl}?${queryString}`, "_blank");
        },
        SymbolMatchedDate(item, val) {
            // console.log(item,val);
            this.monthval = item
            this.SymbolDataMatchedTableArray = []
            if (val == 'mobile') {
                this.dialogForSymDetailsMobile = true
            } else {
                this.dialogForSymDetails = true

            }
            // for (let i = 0; i < this.SymbolDataMatched.length; i++) {

            if (item.month) {
                if (item.hint == 'Jan' || item.hint == 'Feb' || item.hint == 'Mar') {
                    for (let i = 0; i < this.TableData.length; i++) {
                        const element = this.TableData[i];
                        if (element.TRADE_DATE.includes(item.hint) && (element.TRADE_DATE).includes(this.ToDateForApi.split("/")[2])) {
                            this.SymbolDataMatchedTableArray.push(element)
                        }
                    }
                } else {
                    for (let i = 0; i < this.TableData.length; i++) {
                        const element = this.TableData[i];
                        if (element.TRADE_DATE.includes(item.hint) && (element.TRADE_DATE).includes(this.FromDateForApi.split("/")[2])) {
                            this.SymbolDataMatchedTableArray.push(element)
                        }
                    }
                }

                // console.log(this.SymbolDataMatchedTableArray, "march");

            } else if (this.SymbolDataMatched[item.SCRIP_SYMBOL]) {
                this.SymbolDataMatchedTableArray = this.SymbolDataMatched[item.SCRIP_SYMBOL]
            }
            // }
            // console.log(this.SymbolDataMatchedTableArray);
        },

        reset() {
            this.maxval = this.resetrange
            this.minval = this.resetrangemin
            this.fromdate = []
            this.highlightyearsValue = ''
        },
        GetDataWithYearSelector(valuevalue, item) {
            // this.postalready = false
            this.agreeforshare = false
            this.postalready = false
            this.highlightyearsValue = item
            //console.log(this.highlightyearsValue);
            this.menuForDatePicker = false
            let valuedate = valuevalue
            this.loader = true
            this.menuForDatePickerMobile = false
            var today = new Date();
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            var offset = valuedate * -1;
            var yearmount = ""
            var yearnext = ""
            if (mm < 4) {
                yearmount = yyyy - 1 - offset;
                yearnext = yyyy - offset;
            } else {
                yearmount = yyyy - offset;
                yearnext = yyyy + 1 - offset;
            }



            this.fromdate = []
            this.fromdate.push(yearmount + '-' + '04' + '-' + '01');
            this.loader = true
            this.fromdate.push(yearnext + '-03-31')
            this.fromshow = '01' + '/' + '04' + '/' + yearmount + '_to_' + '31/03/' + yearnext
            this.datemaxvalue()
            this.FromDateForApi = '01' + '/' + '04' + '/' + yearmount
            this.ToDateForApi = '31/03/' + yearnext
            this.DataGetApi()

        },
        filterseg(item) {
            console.log("itemmm",item)
            if (item == 'mobile' && this.fromdate.length < 2) {
                this.menuForDatePickerMobile = true

            } else if (this.fromdate.length < 2) {
                this.menuForDatePicker = true
            } else {
                this.getCalenderData()
            }
        },
        datemaxvalue(item) {
            let valuefordate = this.fromdate
            this.minval = this.fromdate[0]
            //console.log(valuefordate);
            //    if (this.fromdate.length < 1) {
            //         this.fromdate = valuefordate
            //         //console.log(this.fromdate.length,this.fromdate)

            //    }else{
            //         this.fromdate = []
            //         this.fromdate = valuefordate
            // //console.log(valuefordate[0].split("-")[0])

            //    }

            // this.maxval = `${Number(valuefordate.split("-")[0]) + 1}-03-31`
            // //console.log(valuefordate,this.maxval,typeof(Number(valuefordate.split("-")[0])))
            // //console.log(valuefordate[0])
            // //console.log(Number(valuefordate[1]))
            // if (condition) {

            // }
            // if (Number(valuefordate[0].split("-")[1]) > 3) {
            //     this.maxval = `${Number(valuefordate[0].split("-")[0]) + 1}-03-31`

            //     // //console.log(this.maxval,"huhu");
            //     // if (item != 'mounted') {
            //     //     this.todate = `${Number(valuefordate.split("-")[0]) + 1}-03-31`
            //     // }
            //     // //console.log(this.maxval,"1")
            // }
            // else {
            //     this.maxval = `${Number(valuefordate[0].split("-")[0])}-03-31`
            //     // //console.log(this.maxval,"2")
            //     // //console.log(this.maxval,"huhu");

            //     // if (item != 'mounted') {
            //     //         this.todate = `${Number(valuefordate.split("-")[0])}-03-31`
            //     // }
            // }

            if (item == 'click' && valuefordate.length > 1) {
                this.getCalenderData()
                this.highlightyearsValue = ''
            }
        },
        getCalenderData() {
            this.Nodata = true
            this.menuForDatePicker = false
            this.menuForDatePickerMobile = false
            this.loader = true
            let dateString = this.fromdate[0]
            let dateObject = new Date(dateString);
            let year = dateObject.getFullYear();
            let month = dateObject.getMonth() + 1; // Months are 0-indexed, so add 1
            let day = dateObject.getDate();
            let formattedDate = (day < 10 ? '0' : '') + day + '/' + (month < 10 ? '0' : '') + month + '/' + year;
            this.FromDateForApi = formattedDate
            let dateString1 = this.fromdate[1]
            let dateObject1 = new Date(dateString1);
            let year1 = dateObject1.getFullYear();
            let month1 = dateObject1.getMonth() + 1; // Months are 0-indexed, so add 1
            let day1 = dateObject1.getDate();
            this.ToDateForApi = (day1 < 10 ? '0' : '') + day1 + '/' + (month1 < 10 ? '0' : '') + month1 + '/' + year1;
            this.fromshow = this.FromDateForApi + '_' + 'to' + '_' + this.ToDateForApi
            this.datemaxvalue()
            this.DataGetApi()

        },
        chart() {
            console.log(((this.fromdate[0]).split("-")[0] + '-' + '04' + '-01'));

            const data = [];
            for (let i = 0; i < this.ChartValue.length; i++) {
                data.push(this.ChartValue[i])
            }
            //console.log(data);
            // const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.cal = new CalHeatmap();
            this.cal.paint({
                data: { source: data, x: "date", y: "score" },
                date: { start: new Date((this.fromdate[0]).split("-")[0] == (this.fromdate[1]).split("-")[0] ? (this.fromdate[0]).split("-")[1] < 4 ? ((Number((this.fromdate[0]).split("-")[0]) - 1) + '-' + '04' + '-01') : ((this.fromdate[0]).split("-")[0] + '-' + '04' + '-01') : (this.fromdate[0]).split("-")[0] + '-' + '04' + '-01') },

                range: 12,
                scale: {
                    color:
                        { range: this.rangeColr, type: 'linear', interpolate: 'hsl', domain: this.rangeValue }
                    //     color: function (date, value, dayjsDate) {
                    //     //console.log(value, dayjsDate,date);
                    //     if (value > 0) {
                    //         return {
                    //             type: "quantize",
                    //             scheme: 'Greens',
                    //             domain: [-100000, 100000]
                    //         };
                    //     } else {
                    //         return {
                    //             type: "quantize",
                    //             scheme: 'Reds',
                    //             domain: [-100000, 100000]
                    //         };
                    //     }
                    // }
                },
                domain: {
                    type: 'month',
                    // label: "MM",
                    gutter: 6
                },
                subDomain: {
                    type: 'day', radius: 2, width: 17,
                    // label: 'DD',
                    height: 17,
                },
                itemSelector: '#cal-heatmap',
                // itemSelector: '#cal-heatmap',

            },
                [
                    [
                        CalendarLabel,
                        {
                            position: 'left',
                            key: 'left',
                            text: () => ['', 'Mon', '', 'Wed', '', 'Fri', ''],
                            textAlign: 'end',
                            width: 30,
                            padding: [0, 5, 0, 0],
                        },
                    ],
                    // [
                    //     LegendLite,
                    //     {
                    //     radius: 3,
                    //     itemSelector: '#cal-heatmap',
                    //     },
                    // ],
                    [
                        Tooltip,
                        {
                            text: function (date, value, dayjsDate) {
                                // console.log('valvalvalvalvalvalvalvlavla',dayjsDate ,date);
                                return value == null ? "" : `Realised P&L  ${(value).toFixed(2)} <br> ${dayjsDate.format('LL')}`;
                            },
                        },
                    ],

                ]

            );
        },

        chartMobile() {

            const data = [];
            for (let i = 0; i < this.ChartValue.length; i++) {
                data.push(this.ChartValue[i])
            }
            //console.log(data);
            // const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.cal = new CalHeatmap();
            this.cal.paint({
                data: { source: data, x: "date", y: "score" },
                date: { start: new Date((this.fromdate[0]).split("-")[0] == (this.fromdate[1]).split("-")[0] ? (this.fromdate[0]).split("-")[1] < 4 ? ((Number((this.fromdate[0]).split("-")[0]) - 1) + '-' + '04' + '-01') : ((this.fromdate[0]).split("-")[0] + '-' + '04' + '-01') : (this.fromdate[0]).split("-")[0] + '-' + '04' + '-01') },

                //   verticalOrientation: true,
                range: 12,
                scale: {
                    color:
                        { range: this.rangeColr, type: 'linear', interpolate: 'hsl', domain: this.rangeValue }
                    //     color: function (date, value, dayjsDate) {
                    //     //console.log(value, dayjsDate,date);
                    //     if (value > 0) {
                    //         return {
                    //             type: "quantize",
                    //             scheme: 'Greens',
                    //             domain: [-100000, 100000]
                    //         };
                    //     } else {
                    //         return {
                    //             type: "quantize",
                    //             scheme: 'Reds',
                    //             domain: [-100000, 100000]
                    //         };
                    //     }
                    // }
                },
                domain: {
                    type: 'month',
                    // label: "MM",
                    gutter: 6
                },
                subDomain: {
                    type: 'day', radius: 2, width: 25,
                    // label: 'DD',
                    height: 25,
                },
                // itemSelector: '#cal-heatmap',
                itemSelector: '#cal-heatmap2',

            },
                [
                    [
                        CalendarLabel,
                        {
                            position: 'left',
                            key: 'left',
                            text: () => ['', 'Mon', '', 'Wed', '', 'Fri', ''],
                            textAlign: 'end',
                            width: 30,
                            padding: [0, 5, 0, 0],
                        },
                    ],
                    [
                        Tooltip,
                        {
                            text: function (date, value, dayjsDate) {
                                // console.log(value, dayjsDate);
                                return value == null ? "" : `Realised P&L  ${value} <br> ${dayjsDate.format('LL')}`;

                            },
                        },
                    ],

                ]

            );
        },
        MountedDData() {
            this.susertoken = localStorage.getItem("usession");
            this.actid = localStorage.getItem("userid");
            this.username = localStorage.getItem("cname");
            this.yearlist()
            this.cname = localStorage.getItem("cname");
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            if (mm < 4) {
                var yearmount = yyyy - 1
            } else {
                yearmount = yyyy
            }

            this.FromDateForApi = '01' + '/' + '04' + '/' + yearmount;
            this.fromdate.push((yearmount) + '-' + '04' + '-' + '01')

            this.fromdate.push(yyyy + '-' + mm + '-' + dd)
            this.resetrange = yyyy + '-' + mm + '-' + dd
            this.resetrangemin = yearmount  +  '-' + '04' + '-' +'01'  ;
            this.minval = yearmount  +  '-' + '04' + '-' +'01'  ;
            this.ToDateForApi = dd + '/' + mm + '/' + yyyy;
            this.fromshow = (this.FromDateForApi) + '_' + 'to' + '_' + (this.ToDateForApi)
            this.postalready = false
            this.datemaxvalue()
            this.DataGetApi()

        },
        yearlist() {
            var today = new Date();
            let sevthdate = new Date(today);

            let mmsevthdate = String(sevthdate.getMonth() + 1).padStart(2, '0')

            let yyyysevthdate = sevthdate.getFullYear();
            if (mmsevthdate < 4) {
                var yearmount = yyyysevthdate - 1
            } else {
                yearmount = yyyysevthdate
            }
            var startYear = yearmount - 4;
            // this.yearis = yearmount;

            for (let year = yearmount; year >= startYear; year--) {
                // let yeararraytem = []

                this.yearsarray.push(year)
            }
            this.yearsarray = this.yearsarray.slice(2, 5)
            // //console.log(this.yearsarray)
        },
        DataGetApi() {
            this.getclientshare()
            this.calendermontharray = {

                "April": { value: 0 },
                "May": { value: 0 },
                "June": { value: 0 },
                "July": { value: 0 },
                "August": { value: 0 },
                "September": { value: 0 },
                "October": { value: 0 },
                "November": { value: 0 },
                "December": { value: 0 },
                "January": { value: 0 },
                "February": { value: 0 },
                "March": { value: 0 },
            };
            this.TaxesAndCharges = 0
            this.UnRealishedPnl = 0
            this.RealishedPnl = 0
            this.tab = 0
            this.tab2 = 0
            this.TableData = []
            this.DateTableData = []
            this.ChartValue = []
            this.StatArray = []
            if (this.filterdata_unpl == 'Equity') {
                var SegmentValue = 'NSE_CASH,BSE_CASH'
            } else if (this.filterdata_unpl == 'Fno') {
                SegmentValue = 'NSE_FNO,BSE_FNO'
            } else if (this.filterdata_unpl == 'Commodity') {
                SegmentValue = 'MCX,NCDEX,NSE_COM,BSE_COM'
            } else if (this.filterdata_unpl == 'Currency') {
                SegmentValue = 'CD_NSE,CD_BSE,CD_MCX,CD_USE'
            } else if (this.filterdata_unpl == 'All') {
                SegmentValue = 'NSE_CASH,BSE_CASH,NSE_FNO,BSE_FNO,MCX,NCDEX,NSE_COM,BSE_COM,CD_NSE,CD_BSE,CD_MCX,CD_USE'
            }
            const axios = require("axios");
            let data = JSON.stringify({
                "cc": this.actid,
                "from": this.FromDateForApi,
                "to": this.ToDateForApi,
                "segment": SegmentValue
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${apiurl}/getJournalDiary`,
                // url: 'http://192.168.5.141:9003/getJournal',

                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            let axiosthis = this
            axios.request(config)
                .then((response) => {
                    //console.log((response.data));
                    // axiosthis.ChartValue = response.data.journal
                    if (response.data !== 'No Data') {
                        const { data } = response;
                        Object.assign(axiosthis, {
                            shareresdata: data,
                            ChartValue: [],
                            TableData: [],
                            Nodata: false,
                            loader: false,
                            SymbolDataMatched: data.symbolarr,
                            StatArray: data.summary,
                            TaxesAndCharges: data.total_charges
                        });

                        // Filter & sort data
                        axiosthis.TableData = data.Data2
                            .filter(item => item.last === true)
                            .sort((a, b) => new Date(b.TRADE_DATE) - new Date(a.TRADE_DATE));

                        // Chart data processing
                        axiosthis.ChartValue = data.journal
                            .filter(j => j.realisedpnl)
                            .map(j => ({
                                date: (j.TRADE_DATE).split("T")[0],
                                score: Number(parseFloat(j.realisedpnl).toFixed(2)),
                                realisedpnl: j.realisedpnl
                            }));

                        // Calculate realised & unrealised pnl
                        const pnlTotals = data.Data2.reduce(
                            (totals, item) => {
                                totals.RealishedPnl += Number(item.realisedpnl);
                                totals.UnRealishedPnl += Number(item.unrealisedpnl);
                                return totals;
                            },
                            { RealishedPnl: 0, UnRealishedPnl: 0 }
                        );

                        Object.assign(axiosthis, pnlTotals);

                        // Process DateTableData
                        axiosthis.DateTableData = Object.entries(data.Data)
                            .map(([key, value]) => ({ name: key, val: value }))
                            .reverse();

                        // Process Monthly Calendar Data
                        const abbrevToFull = {
                            Jan: "January", Feb: "February", Mar: "March", Apr: "April",
                            May: "May", Jun: "June", Jul: "July", Aug: "August",
                            Sep: "September", Oct: "October", Nov: "November", Dec: "December"
                        };

                        Object.values(data.Data)
                            .flat()
                            .forEach(({ TRADE_DATE, realisedpnl }) => {
                                if (!TRADE_DATE) return;
                                // fix: append Z to make it valid ISO UTC
                                const dateObj = new Date(TRADE_DATE + "Z");
                                const monthAbbr = dateObj.toUTCString().split(" ")[2];
                                const fullMonth = abbrevToFull[monthAbbr];
                                realisedpnl = Number(realisedpnl) || 0;
                                if (fullMonth && axiosthis.calendermontharray[fullMonth]) {
                                    // const before = axiosthis.calendermontharray[fullMonth].value;
                                    axiosthis.calendermontharray[fullMonth].value += realisedpnl;
                                    // console.log(
                                    //     `Updated ${fullMonth}: ${before} + ${realisedpnl} = ${axiosthis.calendermontharray[fullMonth].value}`
                                    // );
                                } else {
                                    console.warn(`Month not found in mapping or calendermontharray:`, fullMonth);
                                }
                            });

                        // Handle chart updates
                        if (!this.cal) {
                            axiosthis.chart();
                            axiosthis.chartMobile();
                        } else {
                            axiosthis.cal.destroy();
                            axiosthis.chart();
                            axiosthis.chartMobile();
                        }
                    }
                    else {
                        // alert("dfghjk")
                        axiosthis.loader = false
                        axiosthis.chart()
                        axiosthis.chartMobile()
                        axiosthis.ChartValue = []

                        axiosthis.Nodata = true
                        axiosthis.TableData = []
                        axiosthis.TaxesAndCharges = 0
                        axiosthis.UnRealishedPnl = 0
                        axiosthis.UnRealishedPnl = 0
                    }
                    //console.log(axiosthis.ChartValue);

                })
                .catch((error) => {
                    console.log(error);
                    axiosthis.msg = error.message
                    axiosthis.loader = false
                    axiosthis.alert = true
                    axiosthis.coloralert = 'error'

                });
        },
        getclientshare() {
            const axios = require("axios");
            // if (this.filterdata_unpl == 'Equity') {
            //     var SegmentValue = 'NSE_CASH,BSE_CASH'
            // } else if (this.filterdata_unpl == 'Fno') {
            //     SegmentValue = 'NSE_FNO,BSE_FNO'
            // } else if (this.filterdata_unpl == 'Commodity') {
            //     SegmentValue = 'MCX,NCDEX,NSE_COM,BSE_COM'
            // } else if (this.filterdata_unpl == 'Currency') {
            //     SegmentValue = 'CD_NSE,CD_BSE,CD_MCX,CD_USE'
            // } else if (this.filterdata_unpl == 'All') {
            //     SegmentValue = 'NSE_CASH,BSE_CASH,NSE_FNO,BSE_FNO,MCX,NCDEX,NSE_COM,BSE_COM,CD_NSE,CD_BSE,CD_MCX,CD_USE'
            // }
            let data1 = JSON.stringify({
                "cc": this.actid,
                "from": this.fromshow.split("_to_")[0],
                "to": this.fromshow.split("_to_")[1],
                "segment": this.filterdata_unpl
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                // url: 'http://192.168.5.198:5050/getclientsharelist',
                url: `${apiurl}/getclientsharelist`,

                headers: {
                    'Content-Type': 'application/json',
                    'clientid': this.actid,
                    'Authorization': this.susertoken
                },
                data: data1
            };
            let axiosthis = this
            axios.request(config)
                .then((response) => {
                    //console.log(JSON.stringify(response.data));
                    let postval = response.data.msg
                    let res = response.data.data ? response.data.data[0] : []
                    //console.log(res);
                    axiosthis.postalreadyucode = res.uq_code
                    axiosthis.postalreadystats = res.sharing
                    axiosthis.copytext = `${apidailypnl}/dailypnl?ucode=${axiosthis.postalreadyucode}`

                    // axiosthis.copytext = `http://localhost:8080/dailypnl?ucode=${axiosthis.postalreadyucode}`
                    // axiosthis.copytext = `http://192.168.5.117:8080/dailypnl?ucode=${axiosthis.postalreadyucode}`



                    axiosthis.uniqueCode = axiosthis.postalreadyucode
                    if (axiosthis.postalreadystats == 'True') {
                        axiosthis.agreeforshare = true
                        // axiosthis.postalready = true
                    } else if (axiosthis.postalreadystats == 'False') {
                        axiosthis.agreeforshare = false
                        axiosthis.postalready = false
                    }
                    //console.log(axiosthis.postalreadystats, axiosthis.postalreadyucode);
                    if (postval == 'No Data Available') {
                        axiosthis.postalready = false
                        axiosthis.agreeforshare = false


                    } else {
                        axiosthis.postalready = true

                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.MountedDData()
    }
};
</script>

<style lang="scss">
.basil {
    background-color: #FFFBE6 !important;
}

.basil--text {
    color: #020202 !important;
}

.v-tab {
    text-transform: none !important;
}

.v-tabs--grow>.v-tabs-bar .v-tab {
    /* flex: 1 0 auto; */
    max-width: none !important;
}
</style>